import React from 'react';
import profanity from 'leo-profanity';

import {isAdminPage, roundedElements} from 'Services/BaseHelpers';

import Label from './Label';
import RawInput from './RawInput';

const Input = React.forwardRef(({
    containerClassName,
    className,
    type,
    label,
    id,
    onChange,
    value,
    instructions,
    error = null,
    profanityCheck = false,
    labelColour = 'text-white',
    ...rest
}, ref) => {
    let classes = `
        ${isAdminPage() ?
            'focus:ring-light-blue-500 focus:border-light-blue-500' :
            'focus:ring-app-primary-focus focus:border-app-primary-focus'}
        block w-full border-app-blue border-2 shadow-sm py-2 px-3 focus:outline-none sm:text-sm text-app-blue
        ${error ? 'border-red-800' : 'border-gray-300'}
        ${roundedElements() ? 'rounded-xl' : ''}
        ${className && className.includes('mt-0') ? '' : 'mt-1'}
        ${className}
    `;

    if (!isAdminPage()) {
        // overwrite classes as required for non-admin pages.
    }

    return (
        <div className={containerClassName}>
            {label && (
                <Label
                    label={label}
                    htmlFor={id}
                    instructions={instructions}
                    error={error}
                    textColor={ error ? 'text-red-800' :  isAdminPage() ? 'text-black' : labelColour }
                />
            )}

            {label === '' && error && (
                <div className="text-sm text-red-800 mb-1">
                    {error.join(' ')}
                </div>
            )}

            <RawInput
                ref={ref}
                type={type}
                id={id}
                value={value ?? ''}
                onChange={(e) => onChange(profanityCheck ? profanity.clean(e, '') : e)}
                className={classes}
                {...rest}
            />
        </div>
    );
});

export default Input;
